
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.SummaryViewColumnGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class SummaryViewColumnGrid extends SiteEntityGrid<SummaryViewColumnRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.SummaryViewColumn'; }
        protected getDialogType() { return SummaryViewColumnDialog; }
        protected getIdProperty() { return SummaryViewColumnRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewColumnRow.localTextPrefix; }
        protected getService() { return SummaryViewColumnService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        private _viewCode: string;

        public set viewCode(value: string) {
            if (this._viewCode !== value) {
                this._viewCode = value;
                this.setEquality(SummaryViewColumnRow.Fields.ViewCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<SummaryViewColumnRow>{
                ViewCode: this._viewCode
            });
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._viewCode;
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._viewCode);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }
    }
}